"use client";

import React, { createContext, useContext, useState } from "react";

export interface SettingsContextType {
  isSettingsOpen: boolean;
  setIsSettingsOpen: (isSettingsOpen: boolean) => void;
}

const SettingsContext: React.Context<SettingsContextType | null> =
  createContext<SettingsContextType | null>(null);

export function SettingsContextWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  return (
    <SettingsContext.Provider
      value={{
        isSettingsOpen,
        setIsSettingsOpen,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettingsContext() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("Unable to use context for user auth data");
  }
  return context;
}
